module.exports = __webpack_public_path__ + "static/media/close-bg.1d31835a.svg";